<template><div><h3>Masker_COM</h3>
<img width="100" src="http://qr.topscan.com/api.php?text=https%3A%2F%2Fvux.li%2Fdemos%2Fv2%2F%23%2Fcomponent%2Fmasker"/>
<p><a href="https://vux.li/demos/v2/#/component/masker" target="_blank" style="font-size:12px;color:#888;">demo 原始链接：https://vux.li/demos/v2/#/component/masker</a></p>
<hr>
<h4>演示</h4>
 <div style="width:377px;height:667px;display:inline-block;border:1px dashed #ececec;border-radius:5px;overflow:hidden;">
   <iframe src="https://vux.li/demos/v2/#/component/masker" width="375" height="667" border="0" frameborder="0"></iframe>
 </div>
<h4>demo 代码</h4>
<p class="tip">下面的$t是Demo的i18n使用的翻译函数，一般情况下可以直接使用字符串。另外，下面代码隐藏了i18n标签部分的代码。</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"margin: 10px;overflow: hidden;"</span> <span class="hljs-attr">v-for</span>=<span class="hljs-string">"item in list"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">masker</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"border-radius: 2px;"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"m-img"</span> <span class="hljs-attr">:style</span>=<span class="hljs-string">"{backgroundImage: 'url(' + item.img + ')'}"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"m-title"</span>&gt;</span>
          <span>{{</span>item.title<span>}}</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">br</span>/&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"m-time"</span>&gt;</span>2016-03-18<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">masker</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"margin: 10px;overflow: hidden;"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">masker</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"border-radius: 2px;"</span> <span class="hljs-attr">color</span>=<span class="hljs-string">"F9C90C"</span> <span class="hljs-attr">:opacity</span>=<span class="hljs-string">"0.8"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"m-img"</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"background-image:url(https://cdn.xiaotaojiang.com/uploads/56/4b3601364b86fdfd234ef11d8712ad/_.jpg)"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"m-title"</span>&gt;</span>
          VUX
          <span class="hljs-tag">&lt;<span class="hljs-name">br</span>/&gt;</span>
          <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"m-time"</span>&gt;</span>2016-03-18<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">masker</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">import</span> { Masker } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">components</span>: {
    Masker
  },
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">list</span>: [{
        <span class="hljs-attr">title</span>: <span class="hljs-string">'洗颜新潮流！人气洁面皂排行榜'</span>,
        <span class="hljs-attr">img</span>: <span class="hljs-string">'https://cdn.xiaotaojiang.com/uploads/82/1572ec37969ee263735262dc017975/_.jpg'</span>
      }, {
        <span class="hljs-attr">title</span>: <span class="hljs-string">'美容用品 &amp; 日用品（上）'</span>,
        <span class="hljs-attr">img</span>: <span class="hljs-string">'https://cdn.xiaotaojiang.com/uploads/59/b22e0e62363a4a652f28630b3233b9/_.jpg'</span>
      }, {
        <span class="hljs-attr">title</span>: <span class="hljs-string">'远离车内毒气，日本车载空气净化器精选'</span>,
        <span class="hljs-attr">img</span>: <span class="hljs-string">'https://cdn.xiaotaojiang.com/uploads/56/4b3601364b86fdfd234ef11d8712ad/_.jpg'</span>
      }]
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">style</span> <span class="hljs-attr">lang</span>=<span class="hljs-string">"less"</span>&gt;</span><span class="css">
<span class="hljs-selector-class">.m-img</span> {
  <span class="hljs-attribute">padding-bottom</span>: <span class="hljs-number">33%</span>;
  <span class="hljs-attribute">display</span>: block;
  <span class="hljs-attribute">position</span>: relative;
  <span class="hljs-attribute">max-width</span>: <span class="hljs-number">100%</span>;
  <span class="hljs-attribute">background-size</span>: cover;
  <span class="hljs-attribute">background-position</span>: center center;
  <span class="hljs-attribute">cursor</span>: pointer;
  <span class="hljs-attribute">border-radius</span>: <span class="hljs-number">2px</span>;
}

<span class="hljs-selector-class">.m-title</span> {
  <span class="hljs-attribute">color</span>: <span class="hljs-number">#fff</span>;
  <span class="hljs-attribute">text-align</span>: center;
  <span class="hljs-attribute">text-shadow</span>: <span class="hljs-number">0</span> <span class="hljs-number">0</span> <span class="hljs-number">2px</span> <span class="hljs-built_in">rgba</span>(0, 0, 0, .5);
  <span class="hljs-attribute">font-weight</span>: <span class="hljs-number">500</span>;
  <span class="hljs-attribute">font-size</span>: <span class="hljs-number">16px</span>;
  <span class="hljs-attribute">position</span>: absolute;
  <span class="hljs-attribute">left</span>: <span class="hljs-number">0</span>;
  <span class="hljs-attribute">right</span>: <span class="hljs-number">0</span>;
  <span class="hljs-attribute">width</span>: <span class="hljs-number">100%</span>;
  <span class="hljs-attribute">text-align</span>: center;
  <span class="hljs-attribute">top</span>: <span class="hljs-number">50%</span>;
  <span class="hljs-attribute">transform</span>: <span class="hljs-built_in">translateY</span>(-50%);
}

<span class="hljs-selector-class">.m-time</span> {
  <span class="hljs-attribute">font-size</span>: <span class="hljs-number">12px</span>;
  <span class="hljs-attribute">padding-top</span>: <span class="hljs-number">4px</span>;
  <span class="hljs-attribute">border-top</span>: <span class="hljs-number">1px</span> solid <span class="hljs-number">#f0f0f0</span>;
  <span class="hljs-attribute">display</span>: inline-block;
  <span class="hljs-attribute">margin-top</span>: <span class="hljs-number">5px</span>;
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">style</span>&gt;</span>

</code></pre>
<h4>Github Issue</h4>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// masker-390.vue?3de3c2f1